module.exports = __webpack_public_path__ + "static/media/SymbolInput.3e39acae.svg";